import React from 'react';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import { formatNumber } from '../../../../../../logic/otherUtilities/formatting/formatNumber';
import VoxelTrendChip from '../../../../../voxel/Chips/VoxelTrendChip';
import VoxelDataTableCell from '../../../../../voxel/DataTable/VoxelDataTableCell';
import { TrackingData } from './TableCellDomain';

export interface TableCellTrafficTrendProps {
  firstTrackingValue?: TrackingData;
  lastTrackingValue?: TrackingData;
  rankCtrValues?: Record<string, number>;
  keyword: ProjectKeywordGq;
  borderRight?: boolean;
}

const TableCellTrafficTrend: React.FC<TableCellTrafficTrendProps> = ({
  firstTrackingValue,
  lastTrackingValue,
  rankCtrValues,
  keyword,
  borderRight,
}) => {
  if (firstTrackingValue === lastTrackingValue || !firstTrackingValue || !lastTrackingValue)
    return <VoxelDataTableCell className={`${borderRight && 'border-r'}`} />;

  const firstTrafficValue: number = firstTrackingValue?.trackingRank?.rank
    ? (rankCtrValues[firstTrackingValue?.trackingRank?.rank] / 100) * keyword?.volume
    : 0;
  const lastTrafficValue: number = lastTrackingValue?.trackingRank?.rank
    ? (rankCtrValues[lastTrackingValue?.trackingRank?.rank] / 100) * keyword?.volume
    : 0;
  const trendTrafficValue = lastTrafficValue - firstTrafficValue;
  const trendTrafficPositive = trendTrafficValue > 0;
  const trendTrafficSame = trendTrafficValue === 0;

  return (
    <VoxelDataTableCell align="right" className={`${borderRight && 'border-r'}`}>
      <div className="flex flex-row justify-end items-center flex-nowrap">
        <VoxelTrendChip
          title={<>{trendTrafficPositive ? '+' : ''}{formatNumber(trendTrafficValue, 0)}</>}
          color={trendTrafficPositive ? 'success' : trendTrafficSame ? 'neutral' : 'error'}
          size='xs'
        />
      </div>
    </VoxelDataTableCell>
  );
};

export default TableCellTrafficTrend;
